export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/d3-zoom/src/constant.js
// module id = ../../../../d3-zoom/src/constant.js
// module chunks = 3